// Bright pixels push towards the camera
vec3 displace(vec3 pos, vec2 uv, inout float elevation)
{
    elevation = luma(sampleCam(uv));
    pos += normal * elevation * uStrength;
    return pos;
}
